<script lang="ts">
  import { Button, Col, Modal, ModalBody, Row } from "sveltestrap"
  import TxModal from "./TxModal.svelte"
  import { selectedAccount, web3, chainId } from "svelte-web3"
  import { COREABI } from "../abis/core"
  import { nFormatter } from "../utils/utils"
  import { ERC721ABI } from "../abis/erc721"
  import { CONFIG } from "../config"

  export let data: object
  export let action: string;

  let isOpen = false;
  let acceptTxModalOpen = false;
  let approveTxModalOpen = false;
  let rawAmount = '';
  let amount = 0;
  let txHash = '';
  let approved = false;

  const toggle = () => (isOpen = !isOpen);

  const approve = () => {
    const metaNft = new $web3.eth.Contract(ERC721ABI, CONFIG[$chainId].META_NFT_ADDRESS);
    metaNft.methods.approve(CONFIG[$chainId].CORE_ADDRESS, data.metaNftId).send( {from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        txHash = hash;
        approveTxModalOpen = true;
      })
      .on('receipt', receipt => {
        console.log(receipt);
        approved = true;
      })
  }

  const submit = () => {
    const pilgrim = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
    const method = action === 'NFT' ? pilgrim.methods.acceptNftBid : pilgrim.methods.acceptMetaNftBid;
    method(data.metaNftId, rawAmount, Math.round(Date.now() / 1000 + 30000)).send({ from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        txHash = hash;
        isOpen = false;
        acceptTxModalOpen = true;
      })
  }

  const getAmount = async () => {
    const pilgrim = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
    const res = await pilgrim.methods.quoteNft(data.metaNftId).call();
    rawAmount = res[1];
    amount = Number.parseInt(res[1]) / Math.pow(10, data.baseTokenDecimals);
  }

  $: if (isOpen) {
    getAmount();
  }
</script>


<Button class="button-fill pf-table-action-button" on:click={toggle}>
  {#if action === 'NFT'}
    <img class="icon-small" src="/icons/nft.svg" alt="placeholder"/>
  {:else}
    <img class="icon-small" src="/icons/meta-nft.svg" alt="placeholder"/>
  {/if}
  Accept {action} Bid
</Button>
<Modal class="pil-modal" isOpen={isOpen} {toggle}>
  <ModalBody class="pil-modal-body">
    <Row>
      <Col class="modal-title">
        Confirm bidding offer on your {action}
      </Col>
      <Col class="col-auto">
        <img class="icon-large" src="/icons/close.svg" alt="placeholder" on:click={toggle}/>
      </Col>
    </Row>
    <Row>
      <Col class="modal-sub-title">
        You will receive
      </Col>
    </Row>
    <Row>
      <Col class="modal-amount-value">
        {nFormatter(amount, 2)} <span class="modal-amount-unit">{data.baseToken}</span>
      </Col>
    </Row>
    <Row class="warning-box gx-0">
      <Col class="col-auto">
        <img class="icon-small" src="/icons/warning.svg" alt="placeholder"/>
      </Col>
      <Col>
        <p class="warning">
          Transfer collected PIL to your wallet before accepting the offer.
          <br/>
          <br/>
          By accepting this bid offer, you are transfering the sole ownership of this {action} to the new owner. The unclaimed PIL related to this item will NOT be claimable after this transaction.
        </p>
      </Col>
    </Row>
    <Row class="justify-content-center">
      <Col class="col-auto">
        {#if approved}
          <Button class="button-fill accept-button" on:click={submit}>
            I understand & accept bid offer
          </Button>
        {:else}
          <Button class="button-fill accept-button" on:click={approve}>
            Approve MetaNFT
          </Button>
        {/if}
      </Col>
    </Row>
  </ModalBody>
</Modal>
<TxModal isOpen={approveTxModalOpen} msg="Approve transaction is initiated" txHash={txHash}/>
<TxModal isOpen={acceptTxModalOpen} msg="Your {action} is sold!" txHash={txHash}/>
